import { Outlet } from "react-router-dom";
import styles from "./Layout.module.scss";
import { Footer } from "./Footer";

export const Layout = () => {
  return (
    <div className={styles.wrapbg}>
      <div className={styles.wrapper}>
        <Outlet />
        <Footer />
      </div>
    </div>
  );
};
